// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray {\n  color: #cccccc;\n}\n.fs-117em {\n  font-size: 1.17em;\n}\n.group-member-wrapper .ant-card-body {\n  padding: 0;\n}\n.group-member-list {\n  display: absolute;\n  top: 0;\n  bottom: 0;\n}\n.group-member-list .ant-table {\n  width: 100%;\n}\n.group-member-item {\n  font-size: 1.17em;\n  color: black;\n}\n", ""]);
// Exports
module.exports = exports;
